import React, { useState } from "react";
import "./Month.scss";
import DatePicker, { registerLocale } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import ko from "date-fns/locale/ko";
import Bar from "./Bar";
const Month = () => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className="Month">
      <div className="calendar">
        <h1>날짜를 선택하세요!</h1>
        <DatePicker
          locale="ko"
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          inline
        />
      </div>

      <div className="nav-bar2">
        <Bar></Bar>
      </div>
    </div>
  );
};

export default Month;
